import { useInView } from '../../../hooks/useInView';

export default function Booking() {
  const { ref, isInView } = useInView<HTMLDivElement>({ threshold: 0.2 });

  return (
    <section id="booking" className="py-20 sm:py-28 lg:py-36 bg-offwhite">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
        {/* Background decorative */}
        <div className="relative">
          {/* Section label */}
          <p className="section-label mb-6">RESERVATION</p>

          {/* Title */}
          <div
            ref={ref}
            className="mb-6 transition-all duration-700"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(32px)',
            }}
          >
            <h2 className="font-serif-jp text-charcoal leading-snug mb-4" style={{ fontSize: 'clamp(28px, 5vw, 48px)' }}>
              ご予約・お問い合わせ
            </h2>
            <div className="gold-divider mx-auto mb-6" />
            <p className="font-sans-jp text-salon-gray" style={{ fontSize: 'clamp(13px, 1.8vw, 15px)', lineHeight: '1.9' }}>
              お電話またはLINE公式アカウントからご予約を承っております。
              <br className="hidden sm:block" />
              初回カウンセリングのお時間を15分設けておりますので、お気軽にご相談ください。
            </p>
          </div>

          {/* Buttons */}
          <div
            className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6 mt-10"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.7s ease-out 0.2s, transform 0.7s ease-out 0.2s',
            }}
          >
            {/* Phone button */}
            <a
              href="tel:03-1234-5678"
              className="group flex items-center gap-4 bg-charcoal text-offwhite whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-charcoal/80 w-full sm:w-auto justify-center"
              style={{
                padding: '18px 36px',
                borderRadius: '2px',
                minWidth: '260px',
              }}
            >
              <div className="w-10 h-10 flex items-center justify-center border border-gold/60 flex-shrink-0">
                <i className="ri-phone-line text-gold text-lg" />
              </div>
              <div className="text-left">
                <p className="font-sans-jp" style={{ fontSize: '11px', letterSpacing: '0.2em', color: '#C9A96E' }}>
                  PHONE
                </p>
                <p className="font-sans-jp font-medium" style={{ fontSize: 'clamp(14px, 2vw, 16px)' }}>
                  お電話でのご予約
                </p>
                <p className="font-sans-jp text-offwhite/60" style={{ fontSize: '12px' }}>
                  03-1234-5678
                </p>
              </div>
            </a>

            {/* LINE button */}
            <a
              href="https://lin.ee/example"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group flex items-center gap-4 border border-charcoal text-charcoal whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-charcoal hover:text-offwhite w-full sm:w-auto justify-center"
              style={{
                padding: '18px 36px',
                borderRadius: '2px',
                minWidth: '260px',
              }}
            >
              <div className="w-10 h-10 flex items-center justify-center border border-salon-gray/40 group-hover:border-gold/60 flex-shrink-0 transition-colors duration-300">
                <i className="ri-chat-smile-line text-salon-gray group-hover:text-gold text-lg transition-colors duration-300" />
              </div>
              <div className="text-left">
                <p
                  className="font-sans-jp text-gold group-hover:text-gold"
                  style={{ fontSize: '11px', letterSpacing: '0.2em' }}
                >
                  LINE
                </p>
                <p className="font-sans-jp font-medium" style={{ fontSize: 'clamp(14px, 2vw, 16px)' }}>
                  LINE公式アカウント
                </p>
                <p className="font-sans-jp text-salon-gray group-hover:text-offwhite/60 transition-colors duration-300" style={{ fontSize: '12px' }}>
                  友だち追加でご予約可能
                </p>
              </div>
            </a>
          </div>

          {/* Business hours note */}
          <p
            className="font-sans-jp text-salon-gray mt-10"
            style={{
              fontSize: '12px',
              opacity: isInView ? 1 : 0,
              transition: 'opacity 0.7s ease-out 0.4s',
              letterSpacing: '0.05em',
            }}
          >
            受付時間：10:00〜19:00（水曜定休）
          </p>
        </div>
      </div>
    </section>
  );
}
